const viewportUnits = () => {
	document.documentElement.style.setProperty(
		'--vh',
		`${(window.innerHeight * 0.01) / 16}rem`
	);

	document.documentElement.style.setProperty(
		'--vw',
		`${(document.body.clientWidth * 0.01) / 16}rem`
	);
};

export default viewportUnits;
